var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.875C3.5 4.66789 3.66789 4.5 3.875 4.5H6.125C6.33211 4.5 6.5 4.66789 6.5 4.875C6.5 5.08211 6.33211 5.25 6.125 5.25H3.875C3.66789 5.25 3.5 5.08211 3.5 4.875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.625C2 2.41789 2.16789 2.25 2.375 2.25H7.625C7.83211 2.25 8 2.41789 8 2.625C8 2.83211 7.83211 3 7.625 3H2.375C2.16789 3 2 2.83211 2 2.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.375C0.5 0.167893 0.667893 0 0.875 0H9.125C9.33211 0 9.5 0.167893 9.5 0.375C9.5 0.582107 9.33211 0.75 9.125 0.75H0.875C0.667893 0.75 0.5 0.582107 0.5 0.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a965fe19d8c710d2b086fb0447c7c821.svg";
export { ForwardRef as ReactComponent };